import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1bc8ef66"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "dictionary section-type-selector" }
const _hoisted_2 = { class: "card bg-light mb-3" }
const _hoisted_3 = { class: "card-body" }
const _hoisted_4 = { class: "row" }
const _hoisted_5 = {
  key: 0,
  class: "col-3"
}
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Section", -1))
const _hoisted_7 = {
  key: 1,
  class: "col-3"
}
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", {
  class: "btn btn-outline-secondary float-right",
  "data-toggle": "modal",
  "data-target": "#customerdictionary-types-modal"
}, [
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-ellipsis-h" })
], -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Type", -1))
const _hoisted_10 = {
  key: 2,
  class: "col-6"
}
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", {
  class: "btn btn-outline-secondary float-right",
  "data-toggle": "modal",
  "data-target": "#customerdictionary-items-modal"
}, [
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-ellipsis-h" })
], -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Item", -1))
const _hoisted_13 = {
  key: 0,
  class: "row"
}
const _hoisted_14 = { class: "offset-md-3 col-3" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { style: {"margin-bottom":"0em"} }, "Minimum required", -1))

import { computed, ref, watchEffect } from 'vue';
import { useStore } from 'vuex';
import { DictionarySection, DictionaryType, DictionaryItem, SelectOption } from '@/models';
import SectionTypeSelector from './partials/SectionTypeSelector.vue';
import CustomerDictionaryTypesModal from '@/components/modals/CustomerDictionaryTypesModal.vue';
import CustomerDictionaryItemsModal from '@/components/modals/CustomerDictionaryItemsModal.vue';
import { useToast } from "vue-toastification";

// Props declaration with types

export default /*#__PURE__*/_defineComponent({
  __name: 'SectionTypeSelector',
  props: {
    showSections: { type: Boolean },
    showTypes: { type: Boolean },
    showItems: { type: Boolean }
  },
  setup(__props: any) {

const props = __props;

const store = useStore();
const toasted = useToast();

// State from store
const dictionaryState = computed(() => store.state.customerdictionary);

// Getters
const allSections = computed(() => store.getters['customerdictionary/allSections']);
const currentTypes = computed(() => store.getters['customerdictionary/currentTypes']);
const currentItems = computed(() => store.getters['customerdictionary/currentItems']);
const hasActiveSection = computed(() => store.getters['customerdictionary/hasActiveSection']);
const hasActiveType = computed(() => store.getters['customerdictionary/hasActiveType']);
const hasActiveItem = computed(() => store.getters['customerdictionary/hasActiveItem']);

// Methods converted to arrow functions
const setActiveSection = (section: DictionarySection) => {
  store.commit('customerdictionary/setActiveSection', section);
  unsetActiveType();
};

const setActiveType = (type: DictionaryType) => {
  store.commit('customerdictionary/setActiveType', type);
  unsetActiveItem();
};

const setActiveItem = (item: DictionaryItem) => {
  store.commit('customerdictionary/setActiveItem', item);
};

const activeSection = computed({
  get: () =>  dictionaryState.value.activeSection, // Getter
  set: (newValue) => {
    dictionaryState.value.activeSection = newValue; // Setter
  }
});

const activeType = computed({
  get: () =>  dictionaryState.value.activeType, // Getter
  set: (newValue) => {
    dictionaryState.value.activeType = newValue; // Setter
  }
});

const activeItem = computed({
  get: () =>  dictionaryState.value.activeItem, // Getter
  set: (newValue) => {
    dictionaryState.value.activeItem = newValue; // Setter
  }
});

const minimumRequired = computed({
  get: () =>  {
    let str = activeType.value.minimumRequired.toString();
    return { name: str, slug: str };
  }, // Getter
  set: (newValue) => {
    activeType.value.minimumRequired = parseInt(newValue.name);
    updateType(activeType.value);
  }
});

const updateType = async (type: DictionaryType) => {
  await store.dispatch('customerdictionary/updateType', type);
};

const unsetActiveSection = () => {
  setActiveSection(new DictionarySection());
  unsetActiveType();
};

const unsetActiveType = () => {
  setActiveType(new DictionaryType());
  unsetActiveItem();
};

const unsetActiveItem = () => {
  setActiveItem(new DictionaryItem());
};

const getSystemName = (type: DictionaryType): string => {
  return type.getSystemName();
};

// Computed property for minRequiredOptions
const minRequiredOptions = computed(() => {
  const options: SelectOption[] = [];
  for (let i = 1; i <= 10; i++) {
    let str = i.toString();
    options.push({ name: str, slug: str });
  }
  return options;
});

const unsetMinimumRequired = () => {
  activeType.value.minimumRequired = 0;
  updateType(activeType.value);
};

return (_ctx: any,_cache: any) => {
  const _component_multiselect = _resolveComponent("multiselect")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          (_ctx.showSections)
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                _hoisted_6,
                _createVNode(_component_multiselect, {
                  modelValue: activeSection.value,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((activeSection).value = $event)),
                  "track-by": "slug",
                  options: allSections.value
                }, null, 8, ["modelValue", "options"]),
                _createElementVNode("button", {
                  class: _normalizeClass(["btn btn-link pb-0", { 'text-muted': !hasActiveSection.value }]),
                  onClick: unsetActiveSection
                }, " Clear ", 2)
              ]))
            : _createCommentVNode("", true),
          (_ctx.showTypes && hasActiveSection.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                _hoisted_8,
                _hoisted_9,
                _createVNode(_component_multiselect, {
                  modelValue: activeType.value,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((activeType).value = $event)),
                  "track-by": "slug",
                  "custom-label": getSystemName,
                  options: currentTypes.value
                }, null, 8, ["modelValue", "options"]),
                _createElementVNode("button", {
                  class: _normalizeClass(["btn btn-link pb-0", { 'text-muted': !hasActiveType.value }]),
                  onClick: unsetActiveType
                }, " Clear ", 2)
              ]))
            : _createCommentVNode("", true),
          (_ctx.showItems && hasActiveType.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                _hoisted_11,
                _hoisted_12,
                _createVNode(_component_multiselect, {
                  modelValue: activeItem.value,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((activeItem).value = $event)),
                  "track-by": "slug",
                  options: currentItems.value
                }, null, 8, ["modelValue", "options"]),
                _createElementVNode("button", {
                  class: _normalizeClass(["btn btn-link pb-0", { 'text-muted': !hasActiveItem.value }]),
                  onClick: unsetActiveItem
                }, " Clear ", 2)
              ]))
            : _createCommentVNode("", true)
        ]),
        (_ctx.showTypes && hasActiveSection.value && activeType.value.name == 'Photo')
          ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
              _createElementVNode("div", _hoisted_14, [
                _hoisted_15,
                _createVNode(_component_multiselect, {
                  modelValue: minimumRequired.value,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((minimumRequired).value = $event)),
                  "track-by": "slug",
                  options: minRequiredOptions.value
                }, null, 8, ["modelValue", "options"]),
                _createElementVNode("button", {
                  class: _normalizeClass(["btn btn-link pb-0", { 'text-muted': !hasActiveType.value }]),
                  onClick: unsetMinimumRequired
                }, " Clear ", 2)
              ])
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    _createVNode(CustomerDictionaryTypesModal),
    _createVNode(CustomerDictionaryItemsModal)
  ]))
}
}

})